<!-- Contenedor principal del formulario simplificado -->
<div class="billing-form-container">
  <form [formGroup]="billingForm" (ngSubmit)="onFormSubmit()" class="billing-form">
    <!-- Fila 1: Razón Social y Número de Contrato -->
    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="businessName" class="form-label">
            Razón Social <span class="required-asterisk">*</span>
          </label>
          <input 
            pInputText 
            id="businessName" 
            formControlName="businessName"
            placeholder="Ingrese la razón social para facturación"
            class="w-full"
            [class.ng-invalid]="hasError('businessName', 'required') || hasError('businessName', 'maxlength')"
          />
          <small 
            *ngIf="hasError('businessName', 'required') || hasError('businessName', 'maxlength')"
            class="p-error">
            {{ getErrorMessage('businessName') }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field">
          <label for="contractNumber" class="form-label">
            Número de Contrato <span class="required-asterisk">*</span>
          </label>
          <input 
            pInputText 
            id="contractNumber" 
            formControlName="contractNumber"
            placeholder="Ingrese el número de contrato"
            class="w-full"
            [class.ng-invalid]="hasError('contractNumber', 'required') || hasError('contractNumber', 'maxlength')"
          />
          <small 
            *ngIf="hasError('contractNumber', 'required') || hasError('contractNumber', 'maxlength')"
            class="p-error">
            {{ getErrorMessage('contractNumber') }}
          </small>
        </div>
      </div>
    </div>

    <!-- Fila 2: Forma de Pago, Tipo de Pago y Uso de CFDI -->
    <div class="grid">
      <div class="col-12 md:col-4">
        <div class="field">
          <label for="paymentMethod" class="form-label">
            Forma de Pago <span class="required-asterisk">*</span>
          </label>
          <p-dropdown 
            [options]="paymentMethods" 
            formControlName="paymentMethod"
            optionLabel="label" 
            optionValue="value"
            placeholder="Seleccione la forma de pago"
            class="w-full"
            [class.ng-invalid]="hasError('paymentMethod', 'required')"
          ></p-dropdown>
          <small 
            *ngIf="hasError('paymentMethod', 'required')"
            class="p-error">
            {{ getErrorMessage('paymentMethod') }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4">
        <div class="field">
          <label for="paymentType" class="form-label">
            Tipo de Pago <span class="required-asterisk">*</span>
          </label>
          <p-dropdown 
            [options]="paymentTypes" 
            formControlName="paymentType"
            optionLabel="label" 
            optionValue="value"
            placeholder="Seleccione el tipo de pago"
            class="w-full"
            [class.ng-invalid]="hasError('paymentType', 'required')"
          ></p-dropdown>
          <small 
            *ngIf="hasError('paymentType', 'required')"
            class="p-error">
            {{ getErrorMessage('paymentType') }}
          </small>
        </div>
      </div>

      <div class="col-12 md:col-4">
        <div class="field">
          <label for="cfdiUsage" class="form-label">
            Uso de CFDI <span class="required-asterisk">*</span>
          </label>
          <p-dropdown 
            [options]="cfdiUsages" 
            formControlName="cfdiUsage"
            optionLabel="label" 
            optionValue="value"
            placeholder="Seleccione el uso de CFDI"
            class="w-full"
            [class.ng-invalid]="hasError('cfdiUsage', 'required')"
          ></p-dropdown>
          <small 
            *ngIf="hasError('cfdiUsage', 'required')"
            class="p-error">
            {{ getErrorMessage('cfdiUsage') }}
          </small>
        </div>
      </div>
    </div>

    <!-- Fila 3: Comentarios (ocupa todo el ancho) -->
    <div class="field">
      <label for="comments" class="form-label">
        Comentarios
      </label>
      <textarea 
        pInputTextarea 
        id="comments" 
        formControlName="comments"
        rows="3"
        placeholder="Comentarios adicionales sobre la facturación"
        class="w-full"
        [class.ng-invalid]="hasError('comments', 'maxlength')"
      ></textarea>
      <small 
        *ngIf="hasError('comments', 'maxlength')"
        class="p-error">
        {{ getErrorMessage('comments') }}
      </small>
    </div>

    <!-- Botones de acción -->
    <div class="form-actions">
      <p-button
        [outlined]="true"
        type="button"
        label="Cancelar"
        icon="fas fa-times"
        severity="secondary"
        (click)="onFormCancel()"
        [disabled]="isSubmitting"
      ></p-button>
      
      <p-button 
        type="submit"
        [label]="mode === 'create' ? 'Crear' : 'Actualizar'"
        [icon]="mode === 'create' ? 'fas fa-plus' : 'fas fa-save'"
        severity="primary"
        [disabled]="!isFormValid || isSubmitting"
        [loading]="isSubmitting"
      ></p-button>
    </div>
  </form>
</div>
